
import './App.css';
import {BrowserRouter as Router,Routes, Route} from 'react-router-dom';



import Home from './components/pages/Home';
import Footer from './components/inc/Footer';
import Login from './components/pages/Login';
import Signup from './components/pages/Signup';



import ProtectedRoute from './components/pages/ProtectedRoute';
import UserDashboard from './components/pages/UserDashboard';
import UserAuthContextProvider from './contexts/UserAuthContext';

import firebase from 'firebase/compat/app'

import Farmm from './components/pages/Farmm';
import GardenTools from './components/pages/GardenTools';
import Gardeniry from './components/pages/Gardeniry';
import KitchenDec from './components/pages/KitchenDec';

import Ricemill from './components/pages/Ricemill';
import MiniIndus from './components/pages/MiniIndus';
import Parts from './components/pages/Parts';
import Others from './components/pages/Others';
import About from './components/pages/About';
import Herbal from './components/pages/Herbal';
import HerbalCapsul from './components/pages/HerbalCapsul';
import HerbalJucie from './components/pages/HerbalJucie';
import HerbalDrop from './components/pages/HerbalDrop';
import HerbalTablet from './components/pages/HerbalTablet';
import HerbalPowder from './components/pages/HerbalPowder';
import HerbalOil from './components/pages/HerbalOil';
import HerbalSyrup from './components/pages/HerbalSyrup';
import Cosmetics from './components/pages/Cosmetics';


// import Login from './components/pages/Login';
// import Signup from './components/pages/Signup';
// import NotFound from './components/pages/NotFound';
firebase.initializeApp({
  apiKey: "AIzaSyDaTbOJkxcyn_XwPlup2ZicYKtqBtRwpY0",
  authDomain: "lipo-kart.firebaseapp.com",
  projectId: "lipo-kart",
  storageBucket: "lipo-kart.firebasestorage.app",
  messagingSenderId: "568534822854",
  appId: "1:568534822854:web:803cafde94ca350bbeccc7",
  measurementId: "G-J147CD0ZTK"
})

function App() {
  return (
    <Router>
      <UserAuthContextProvider>
   
<div>



 <Routes>
 <Route axact path="/" element={<Home/>}/>
 <Route axact path="/login" element={<Login/>}/>
 <Route axact path="/signup" element={<Signup/>}/>

 

 <Route axact path="/farm-machinery" element={<Farmm/>}/>
 <Route axact path="/garden-tools" element={<GardenTools/>}/>
 <Route axact path="/Gardeniry" element={<Gardeniry/>}/>
 <Route axact path="/kitchen-decor" element={<KitchenDec/>}/>

 <Route axact path="/Ricemill" element={<Ricemill/>}/>

 <Route axact path="/mini-industries" element={<MiniIndus/>}/>
 <Route axact path="/parts" element={<Parts/>}/>
 <Route axact path="/others" element={<Others/>}/>
 <Route axact path="/about-us" element={<About/>}/>

  <Route axact path="/Herbal" element={<Herbal/>}/>
    <Route axact path="/HerbalCapsul" element={<HerbalCapsul/>}/>
      <Route axact path="/HerbalJucie" element={<HerbalJucie/>}/>
            <Route axact path="/HerbalDrop" element={<HerbalDrop/>}/>
              <Route axact path="/HerbalTablet" element={<HerbalTablet/>}/>
                 <Route axact path="/HerbalPowder" element={<HerbalPowder/>}/>
                       <Route axact path="/HerbalOil" element={<HerbalOil/>}/>
                        <Route axact path="/HerbalSyrup" element={<HerbalSyrup/>}/>
                          <Route axact path="/Cosmetics" element={<Cosmetics/>}/>
 <Route axact path="/UserDashboard/:userId" element={<ProtectedRoute> <UserDashboard/> </ProtectedRoute>}/>

 
 </Routes>
       <Footer/>
     
    </div>
    </UserAuthContextProvider>
    </Router>
  );
}

export default App;
